<template>
    <v-dialog v-model="dialog" max-width="700px" @input="onDialogToggle">
        <v-card>
            <v-card-title
                class="text-h5 aviso"
                style="
                    justify-content: center;
                    background: #1d2735;
                    color: white;
                "
            >
                Generar Tarea
            </v-card-title>
            <v-card-text style="text-align: center">
                <v-alert
                    v-if="!tarea.id_proyecto"
                    type="warning"
                    dense
                    outlined
                    class="text-left mt-3"
                >
                    Selecciona un proyecto en el ticket para ver el tiempo
                    disponible.
                </v-alert>
                <v-row
                    v-if="tarea.id_proyecto"
                    class="mt-2 text-left"
                    dense
                >
                    <v-col cols="12">
                        <div class="caption grey--text text--darken-1 mb-1">
                            {{ etiquetaPeriodo }}
                        </div>
                        <div>
                            <strong>Minutos utilizados:</strong>
                            {{ tiempo_utilizado }}
                        </div>
                        <div>
                            <strong>Minutos asignados:</strong>
                            {{ tiempo_asignado }}
                        </div>
                        <div v-if="pasado < 0">
                            <strong>Minutos excedidos periodo anterior:</strong>
                            <span class="red--text">{{ pasado }}</span>
                        </div>
                        <div>
                            <strong>Minutos disponibles:</strong>
                            <span :class="minutosDisponibles < 0 ? 'red--text' : ''">
                                {{ minutosDisponibles }}
                            </span>
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="space-between" class="mt-2">
                    <v-col cols="12" md="4">
                        <date-select
                            label="Fecha"
                            v-model="tarea.fecha"
                            @input="fetchTiempoProyecto"
                        >
                        </date-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            type="number"
                            min="0"
                            label="Tiempo (minutos)"
                            v-model="tarea.tiempo"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-checkbox
                            label="Incidencia"
                            v-model="tarea.incidencia"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea
                            label="Descripcion"
                            v-model="tarea.descripcion"
                        >
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    large
                    @click="
                        dialog = false;
                        selectedItem = {};
                    "
                    >Cancelar</v-btn
                >
                <v-btn color="success" large @click="saveTarea()">Confirmar</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: [
        "value",
        "id_proyecto",
        "fecha",
        "descripcion",
        "id_ticket",
    ],
    data() {
        return {
            dialog: false,
            tiempo_utilizado: 0,
            tiempo_asignado: 0,
            semanal: 1,
            pasado: 0,
            tarea: {
                id_proyecto: null,
                descripcion: null,
                tiempo: null,
                fecha: null,
                id_usuario: localStorage.getItem("user_id"),
                incidencia: false,
                id_ticket: null,
            },
        };
    },
    computed: {
        minutosDisponibles() {
            return (
                Number(this.tiempo_asignado) -
                Number(this.tiempo_utilizado) +
                Number(this.pasado || 0)
            );
        },
        etiquetaPeriodo() {
            if (this.semanal === 2) {
                return "Resumen del mes del proyecto";
            }
            if (this.semanal === 1) {
                return "Resumen semanal del proyecto";
            }
            return "Resumen total del proyecto";
        },
    },
    created() {
        this.setData();
    },
    watch: {
        id_ticket() {
            this.setData();
        },
        id_proyecto() {
            this.setData();
            this.fetchTiempoProyecto();
        },
        fecha() {
            this.setData();
            this.fetchTiempoProyecto();
        },
        descripcion() {
            this.setData();
        },
        dialog(val) {
            this.$emit("input", val);
            if (val) {
                this.setData();
                this.fetchTiempoProyecto();
            }
        },
        value(val) {
            this.dialog = val;
        },
        "tarea.id_proyecto"() {
            this.fetchTiempoProyecto();
        },
        "tarea.fecha"() {
            this.fetchTiempoProyecto();
        },
    },
    methods: {
        onDialogToggle(val) {
            if (!val) {
                this.$emit("input", false);
            }
        },
        setData() {
            const tarea = this.tarea;
            this.tarea = {
                id_proyecto: this.id_proyecto ?? tarea.id_proyecto,
                descripcion: this.descripcion ?? tarea.descripcion,
                tiempo: tarea.tiempo,
                fecha: this.fecha ?? tarea.fecha,
                id_usuario: localStorage.getItem("user_id"),
                id_ticket: this.id_ticket,
                incidencia: tarea.incidencia ?? false,
            };
        },
        fetchTiempoProyecto() {
            if (!this.tarea.id_proyecto) {
                this.tiempo_utilizado = 0;
                this.tiempo_asignado = 0;
                this.pasado = 0;
                return;
            }
            axios.post("api/tiempo-tarea-proyecto", this.tarea).then((res) => {
                this.tiempo_utilizado = res.data.tiempo ?? 0;
                this.tiempo_asignado = res.data.asignados ?? 0;
                this.semanal = res.data.semanal ?? 1;
                this.pasado = res.data.pasado ?? 0;
            });
        },
        saveTarea() {
            axios.post(`api/save-tarea`, this.tarea).then(
                () => {
                    this.$toast.success("Tarea creada correctamente");
                    this.dialog = false;
                    this.fetchTiempoProyecto();
                },
                () => {
                    this.$toast.error("Error creando tarea");
                }
            );
        },
    },
};
</script>
